// removed by extract-text-webpack-plugin
module.exports = {"alert":"Alert__alert","padBxxxxS":"Alert__padBxxxxS","position-close":"Alert__position-close","positionClose":"Alert__position-close","flex-shrink":"Alert__flex-shrink","flexShrink":"Alert__flex-shrink","on-white":"Alert__on-white","onWhite":"Alert__on-white","hide-sides":"Alert__hide-sides","hideSides":"Alert__hide-sides","padTxxxxSSm":"Alert__padTxxxxSSm"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Alert/Alert.scss
// module id = 1669
// module chunks = 8